





















































import { Component, Vue } from 'vue-property-decorator'
import { Conditions, PdfLink } from '../../modules/class/PdfDownload/Conditions'
import { DownloadLinkInfo } from '../../modules/class/Downloads'
import PdfList from '../../components/PdfLink/PdfList.vue'
import PdfItem from '../../components/PdfLink/PdfItem.vue'
import LinkItem from '../../components/PdfLink/LinkItem.vue'
import PdfFIlter from '../../components/PdfLink/PdfFIlter.vue'
import RemoveTag from '@/components/Parts/RemoveTag.vue'

@Component({
  components: { PdfList, PdfItem, LinkItem, RemoveTag, PdfFIlter }
})
export default class PdfDownloadList extends Vue {
  // --------------------------------------------------------------------------------------------------------------------
  // data

  // 抽出条件（main.tsから連携される）
  private conditions: Conditions = new Conditions()
  private pdfList: DownloadLinkInfo[] = []

  // PDFタイトルのフィルタキーワード
  private filterKeyword = ''

  // --------------------------------------------------------------------------------------------------------------------
  // computed
  /**
   * HTMLから渡されたPDF以外のリンク
   */
  get pdfLinks(): PdfLink[] {
    return this.conditions.pdfLinks
  }

  /**
   * 一覧を表示するかの判定
   */
  get showList(): boolean {
    return this.pdfList.length > 0 || this.pdfLinks.length > 0
  }

  /**
   * フィルタ結果が存在するかの判定
   */
  get hasResult(): boolean {
    return this.filterPdfLinks.length > 0 || this.filterPdfList.length > 0
  }

  /**
   * HTMLから渡されたPDF以外のリンクのフィルタ
   */
  get filterPdfLinks(): PdfLink[] {
    const list = [...this.pdfLinks]

    if (this.filterKeyword.length === 0) {
      return list
    }

    const keyword = this.filterKeyword.toLowerCase()
    return list.filter((p) => {
      return p.linkTitle.toLowerCase().includes(keyword)
    })
  }

  /**
   * PDFタイトルでフィルタリングした結果のリスト
   */
  get filterPdfList(): DownloadLinkInfo[] {
    const list = [...this.pdfList]

    if (this.filterKeyword.length === 0) {
      return list
    }

    const keyword = this.filterKeyword.toLowerCase()
    return list.filter((p) => {
      return p.title.toLowerCase().includes(keyword)
    })
  }

  /**
   * サジェストに表示する対象
   */
  get suggest(): string[] {
    const linkTitles = this.pdfLinks.map((i) => i.linkTitle)
    const pdfTitles = this.pdfList.map((i) => i.title)
    return linkTitles.concat(pdfTitles)
  }

  // --------------------------------------------------------------------------------------------------------------------
  // methods

  /**
   * コンポーネントから渡された一覧を更新
   */
  private updatePdfList(data: DownloadLinkInfo[]) {
    this.pdfList = data
  }

  /**
   * 検索
   */
  private search(keyword: string) {
    this.filterKeyword = keyword
  }
}
